var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WindowModal',{attrs:{"open-modal":_vm.isModalOpen},on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.close.apply(null, arguments)}}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }